import { Reducer } from '@reduxjs/toolkit';
import { FluxStandardAction } from 'redux-promise-middleware';
import { ManualOverwritesState, ManualOverwritesMap } from '../../../types/custom_fields';

const initialState: ManualOverwritesState = {
  manualOverwrites: {},
  loading: false,
  error: null,
};

const reducer: Reducer<ManualOverwritesState, FluxStandardAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FETCH_MANUAL_OVERWRITES_PENDING': {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case 'FETCH_MANUAL_OVERWRITES_FULFILLED': {
      return {
        ...state,
        manualOverwrites: action.payload.data.manual_overwrites || {},
      };
    }
    case 'FETCH_MANUAL_OVERWRITES_REJECTED': {
      return {
        ...state,
        error: action.payload?.response?.data?.message || 'Failed to fetch manual overwrites',
      };
    }
    case 'ADD_MANUAL_OVERWRITE_FULFILLED': {
      const { customFieldId, itemId } = action.meta;
      const currentItems = state.manualOverwrites[customFieldId] || [];

      return {
        ...state,
        manualOverwrites: {
          ...state.manualOverwrites,
          [customFieldId]: [...currentItems, itemId],
        },
        error: null,
      };
    }
    case 'ADD_MANUAL_OVERWRITE_REJECTED': {
      return {
        ...state,
        error: action.payload?.response?.data?.message || 'Failed to add manual overwrite',
      };
    }
    case 'REMOVE_MANUAL_OVERWRITE_FULFILLED': {
      const { customFieldId, itemId } = action.meta;
      const currentItems = state.manualOverwrites[customFieldId] || [];
      const updatedItems = currentItems.filter(id => id !== itemId);

      const newManualOverwrites: ManualOverwritesMap = {
        ...state.manualOverwrites,
      };

      if (updatedItems.length === 0) {
        delete newManualOverwrites[customFieldId];
      } else {
        newManualOverwrites[customFieldId] = updatedItems;
      }

      return {
        ...state,
        manualOverwrites: newManualOverwrites,
        error: null,
      };
    }
    case 'REMOVE_MANUAL_OVERWRITE_REJECTED': {
      return {
        ...state,
        error: action.payload?.response?.data?.message || 'Failed to remove manual overwrite',
      };
    }
  }
  return state;
};

export default reducer;
